// extracted by mini-css-extract-plugin
export default {"container":"Checkbox_container__83Xfv","input":"Checkbox_input__IXK6p","checkmark":"Checkbox_checkmark__g5oxn","label":"Checkbox_label__B5+2e"};